module.exports = __webpack_public_path__ + "media/images/img/tag_company/nttdata_tag-0aff33f48c70f7d643a3e4591f935bd3.png";